import { Maybe } from 'graphql/jsutils/Maybe';

import { IImagesFragment } from 'generated/sanity-graphql';

type ObjectWithMaybeProperty<TKey extends string | symbol | number, TPropValue> = Maybe<
  {
    readonly [key in TKey]?: Maybe<TPropValue>;
  }
>;
export type NoNullFields<Ob> = { [K in keyof Ob]: NonNullable<Ob[K]> };

export const maybeLocale = <TLocaleValue>(
  node: ObjectWithMaybeProperty<'locale', TLocaleValue>
): TLocaleValue | null => node?.locale ?? null;

export const maybeLocaleRaw = <TLocaleRawValue>(
  node: Maybe<ObjectWithMaybeProperty<'localeRaw', TLocaleRawValue>>
) => node?.localeRaw ?? null;

export const maybeLocaleImages = (
  imageNode: Maybe<ObjectWithMaybeProperty<'locale', IImagesFragment | null>>
) => maybeLocale(imageNode)?.app ?? null;
